/**
 * Van Helsin - Traduções PT/EN/ES
 * Blindagem estrutural internacional (GDPR + AI Act ready)
 */

export const LANG_OPTIONS = [
  { code: "pt", label: "Português", flag: "🇧🇷" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

export const t = {
  pt: {
    shieldSubtitle: "Escolha o idioma da plataforma:",
    chooseLang: "Selecionar idioma",
    legalNotice: "Aviso Legal",
    privacyPolicy: "Política de Privacidade",
    termsOfService: "Termos de Uso",
    pricing: "Planos",
    refunds: "Reembolsos",
    dataRequest: "Solicitar dados",
    about: "Sobre",
    confidentialFile: "Arquivo Confidencial",
    aiBanner: "Você está prestes a conhecer um herói esquecido pelo tempo.\n\nAntes de iniciar esta jornada, conheça a origem, a história e o legado de Van Helsin.",
    checkboxLabel: "Entendo que este é um sistema narrativo fictício gerado por IA e não constitui aconselhamento profissional.",
    checkboxShort: "Li e aceito os Termos de Uso.",
    mandatoryCheckbox: "Checkbox obrigatório antes da compra (UE)",
    euConsentTitle: "Consentimento obrigatório (Consumidor UE)",
    euConsentTerms: "Li e aceito os Termos de Uso.",
    euConsentWithdrawal: "Declaro consentimento expresso à execução imediata do serviço digital e reconheço que perco meu direito de arrependimento de 14 dias uma vez que o acesso comece.",
    euConsentConfirm: "Prosseguir para pagamento",
    fictionDisclaimer: "Ficção interativa. Sem aconselhamento profissional.",
    backToChat: "Voltar a IA",
    // Login
    loginTitle: "Digite seu email para despertar o Caçador",
    loginButton: "Entrar",
    loginPlaceholder: "seu@email.com",
    invalidEmail: "Digite um email válido",
    // Intro cinemática
    invokeBtn: "Atreva-se a Invocar Van Helsin",
    skipIntro: "Pular Intro",
    introPreparing: "Breve silêncio antes da tempestade…",
    // Bootstrap / Geo
    validatingJurisdiction: "Validando jurisdição",
    validatingWait: "Aguarde enquanto validamos disponibilidade legal do serviço.",
    geoUnavailable: "Indisponível na sua jurisdição",
    geoCountry: "País detectado",
    geoBrEuOnly: "Atendimento disponível apenas para residentes de BR e UE.",
    viewLegal: "Ver aviso legal",
    // Top bar
    heroOfShadows: "Herói das Sombras",
    financialExorcist: "Exorcista Financeiro",
    planPaid: "Plano: pago (até {{date}})",
    loggedFull: "usuário logado full",
    planFree: "Grátis: {{left}}/{{total}}",
    accessReleased: "Acesso: liberado",
    loading: "Carregando...",
    switchAI: "Trocar IA",
    upgrade: "Upgrade",
    planActive: "Plano ativo",
    accountMemory: "Conta/Memória",
    authorityCta: "Conheça a origem",
    authorityTooltip: "Conheça a origem, os limites e a proposta institucional da IA Van Helsin.",
    authorityStripTitle: "Origem e limites",
    authorityStripText: "Antes de conversar, conheça a origem, os limites e a proposta da IA Van Helsin.",
    authorityStripButton: "Conheça a origem",
    musicActive: "Música: ativa",
    musicPaused: "Música: pausada",
    musicReconnecting: "Música: reconectando...",
    musicWaiting: "Música: aguardando",
    audiobookActive: "Audiobook: ativo",
    resumeMusic: "Reiniciar música",
    stopMusic: "Parar música",
    resumeAudiobook: "Continuar audiobook",
    stopAudiobook: "Parar audiobook",
    prevMusic: "Música anterior",
    nextMusic: "Próxima música",
    // Chat
    you: "Você",
    parableBadge: "Resposta parabólica",
    onlyConclusion: "Só a conclusão",
    moreDirectNext: "Mais direto nas próximas",
    restoreAutoStyle: "Retomar modo normal",
    showConclusion: "Mostrar",
    hideConclusion: "Ocultar",
    shortConclusionUnavailable: "Nao ha uma conclusao curta confiavel disponivel para esta resposta.",
    // Thinking
    thinking1: "Van Helsin está analisando sua pergunta...",
    thinking2: "Cruza memórias e contexto para responder com precisão...",
    thinking3: "Organizando a melhor resposta para você...",
    thinking4: "Refinando os detalhes finais da resposta...",
    earlyMicroLabel: "Pré-resposta",
    earlyMicroIntro: "Antevisão enquanto a resposta completa é preparada.",
    waitBridgeAriaLabel: "Pré-resposta enquanto a análise principal é preparada",
    // Input
    placeholderHero: "Fale com o Herói das Sombras...",
    placeholderFinance: "Fale com o Exorcista Financeiro...",
    placeholderBlocked: "O Arquivo silenciou-te por esta semana.",
    ctaBreakSeal: "Quebrar o Selo",
    ctaEnterArchive: "Login",
    ctaLoginTooltip: "Acessar login no portal oficial.",
    ctaAlreadyHaveSeal: "Já possuo o Selo",
    loginRecoverTitle: "Já pagou e precisa acessar?",
    loginRecoverText: "Use esta opção para primeiro acesso, recuperação de acesso ou reenvio do link de entrada.",
    loginRecoverButton: "Recuperar acesso",
    ctaRecoverPaidAccess: "Paguei e não recebi o e-mail de acesso",
    ctaObtainFullSeal: "Obter o Selo Completo",
    paywallWeeklyExhausted: "O Arquivo silenciou-te por esta semana.",
    basicNoAiPremium: "O Arquivo responde apenas aos portadores do Selo Completo.",
    hunterSuggestionKicker: "Sugestão do Caçador",
    useSuggestion: "Usar sugestao",
    anotherSuggestion: "Outra sugestao",
    quickStartKicker: "Guia do Caçador",
    quickStartClarity: "Ver com clareza",
    quickStartDirect: "Resposta direta",
    quickStartJudgment: "Julgar situação",
    quickStartClarityPrefix: "Quero ver esta situação com clareza:",
    quickStartDirectPrefix: "Quero uma resposta direta sobre:",
    quickStartJudgmentPrefix: "Quero seu julgamento sobre esta situação:",
    quickStartReopen: "Reabrir guia do caçador",
    reopenHunterSuggestion: "Reabrir dica do caçador",
    closeMiniGuide: "Fechar",
    send: "Enviar",
    stop: "Interromper",
    blocked: "Bloqueado",
    // Voice
    voiceTitle: "Idioma da voz",
    stopRecording: "Parar gravação",
    startRecording: "Iniciar gravação",
    voiceUnavailable: "SpeechRecognition indisponível neste navegador",
    voiceUnsupported: "Seu navegador não suporta ditado por voz (SpeechRecognition).",
    voiceStartFail: "Falha ao iniciar o reconhecimento de voz.",
    checkoutFail: "Fluxo de assinatura indisponível no momento. Consulte a página oficial de planos.",
    // Audiobook offer
    audiobookSuggested: "Audiobook sugerido",
    notNow: "Agora não",
    // Modal Conta/Memória
    accountMemoryTitle: "Conta / Memória",
    planPaidActive: "Plano pago ativo (até {{date}}).",
    loggedFullActive: "usuário logado full",
    planFreeUsed: "Plano grátis: {{used}}/{{limit}} usados.",
    accessReleasedPaywall: "Acesso liberado (paywall off).",
    billingUnavailable: "Billing indisponível.",
    doUpgrade: "Fazer upgrade",
    opening: "Abrindo...",
    monthly: "Mensal",
    yearly: "Anual",
    memoryLabel: "Memória",
    memoryOn: "ligada",
    memoryOff: "desligada",
    consentYes: "sim",
    consentNo: "não",
    memoryStatus: "Status de memória indisponível.",
    consentWarning: "Consentimento necessário (LGPD/GDPR). Ao ligar a memória, você autoriza o armazenamento de suas conversas.",
    turnOffMemory: "Desligar memória",
    turnOnMemory: "Ligar memória e dar consentimento",
    deleteSummaries: "Apagar resumos",
    deleteHistory: "Apagar histórico",
    keepLast: "Manter últimos",
    apply: "Aplicar",
    identityCardTitle: "Cartão de Identidade (estilo apenas)",
    identityCardHint: "Personaliza formato e tom das respostas. Não altera moral nem regras.",
    tom: "Tom",
    formato: "Formato",
    detailLevel: "Nível de detalhe",
    avoidPhrases: "Evitar expressões",
    default: "Padrão",
    short: "Curto",
    normal: "Normal",
    bullets: "Lista em tópicos",
    paragraphs: "Parágrafos curtos",
    low: "Baixo",
    medium: "Médio",
    avoidFaca: "Evitar \"faça X\"",
    avoidPrecisa: "Evitar \"você precisa\"",
    avoidMelhor: "Evitar \"o melhor é\"",
    save: "Salvar",
    restoreDefault: "Restaurar padrão",
    clear: "Apagar",
    forgetMe: "Forget-me (apagar tudo)",
    viewMemories: "Ver minhas memórias",
    back: "← Voltar",
    noMemories: "Nenhuma memória encontrada.",
    youFull: "Você (completo)",
    hideReply: "Ocultar resposta",
    showReply: "Ver resposta",
    // Memory status messages
    memoryOnOk: "Memória ligada com consentimento. Suas conversas agora serão salvas!",
    memoryOffOk: "Memória desligada (consentimento mantido).",
    memoryConsentFail: "Memória ligada mas consent falhou. Tente novamente ou contate suporte.",
    memoryError: "Erro ao atualizar memória",
    historyDeleted: "Histórico apagado.",
    historyError: "Erro ao apagar histórico.",
    historyTrimmed: "Histórico ajustado para manter os últimos {{n}}.",
    summariesDeleted: "Resumos apagados.",
    summariesError: "Erro ao apagar resumos.",
    cardSaved: "Cartão salvo.",
    cardSaveFail: "Falha ao salvar. Tente novamente.",
    formCleared: "Formulário limpo. Clique em Salvar para aplicar.",
    cardCleared: "Cartão apagado.",
    cardClearFail: "Falha ao apagar. Tente novamente.",
    forgetDone: "Esquecido. Recarregue a página para obter um novo ID limpo.",
    forgetError: "Erro ao executar forget-me.",
    clearHistoryConfirm: "Apagar TODO o histórico de memória deste user_id?",
    forgetConfirm: "Isso apaga perfil + memórias e cria um novo ID. Continuar?",
    deleteMemoryConfirm: "Apagar memória #{{n}}?",
    loadMemoriesError: "Erro ao carregar lista de memórias.",
    deleteMemoryError: "Erro ao deletar memória.",
    uploadDone: "Upload concluído",
    uploadError: "Erro ao enviar documento",
    rachelOn: "Rachel-E: ON",
    rachelOff: "Rachel-E: OFF",
    rachelTooltip: "Desativação da segunda voz Rachel-E.",
  },
  en: {
    shieldSubtitle: "Choose the platform language:",
    chooseLang: "Select language",
    legalNotice: "Legal Notice",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    pricing: "Pricing",
    refunds: "Refunds",
    dataRequest: "Request data",
    about: "About",
    confidentialFile: "Confidential File",
    rachelOn: "Rachel-E: ON",
    rachelOff: "Rachel-E: OFF",
    rachelTooltip: "Disables the second voice Rachel-E.",
    aiBanner: "You are about to meet a hero forgotten by time.\n\nBefore starting this journey, discover the origin, story, and legacy of Van Helsin.",
    checkboxLabel: "I understand this is an AI-generated fictional narrative system and not professional advice.",
    checkboxShort: "I have read and accept the Terms of Service.",
    mandatoryCheckbox: "Mandatory checkbox before purchase (EU)",
    euConsentTitle: "Required consent (EU consumer)",
    euConsentTerms: "I have read and accept the Terms of Service.",
    euConsentWithdrawal: "I expressly consent to immediate performance of the digital service and acknowledge that I lose my 14-day withdrawal right once access begins.",
    euConsentConfirm: "Proceed to payment",
    fictionDisclaimer: "Interactive fiction. No professional advice.",
    backToChat: "Back to AI",
    loginTitle: "Enter your email to awaken the Hunter",
    loginButton: "Enter",
    loginPlaceholder: "your@email.com",
    invalidEmail: "Please enter a valid email address",
    invokeBtn: "Dare to Invoke Van Helsin",
    skipIntro: "Skip Intro",
    introPreparing: "A brief silence before the storm…",
    validatingJurisdiction: "Validating jurisdiction",
    validatingWait: "Please wait while we validate legal service availability.",
    geoUnavailable: "Unavailable in your jurisdiction",
    geoCountry: "Country detected",
    geoBrEuOnly: "Service available only to residents of Brazil and the EU.",
    viewLegal: "View legal notice",
    heroOfShadows: "Hero of the Shadows",
    financialExorcist: "Financial Exorcist",
    planPaid: "Plan: paid (until {{date}})",
    loggedFull: "full user logged in",
    planFree: "Free: {{left}}/{{total}}",
    accessReleased: "Access: released",
    loading: "Loading...",
    switchAI: "Switch AI",
    upgrade: "Upgrade",
    planActive: "Plan active",
    accountMemory: "Account/Memory",
    authorityCta: "Know the origin",
    authorityTooltip: "Learn the origin, limits and institutional purpose of the Van Helsin AI.",
    authorityStripTitle: "Origin and limits",
    authorityStripText: "Before you talk, learn the origin, limits and purpose of the Van Helsin AI.",
    authorityStripButton: "Know the origin",
    musicActive: "Music: active",
    musicPaused: "Music: paused",
    musicReconnecting: "Music: reconnecting...",
    musicWaiting: "Music: waiting",
    audiobookActive: "Audiobook: active",
    resumeMusic: "Resume music",
    stopMusic: "Stop music",
    resumeAudiobook: "Resume audiobook",
    stopAudiobook: "Stop audiobook",
    prevMusic: "Previous music",
    nextMusic: "Next music",
    you: "You",
    parableBadge: "Parabolic reply",
    onlyConclusion: "Just the conclusion",
    moreDirectNext: "More direct next time",
    restoreAutoStyle: "Return to default style",
    showConclusion: "Show",
    hideConclusion: "Hide",
    shortConclusionUnavailable: "A short direct conclusion is not safely available for this answer.",
    thinking1: "Van Helsin is analyzing your question...",
    thinking2: "Cross-referencing memories and context to respond accurately...",
    thinking3: "Organizing the best response for you...",
    thinking4: "Refining the final details of the response...",
    earlyMicroLabel: "Early reply",
    earlyMicroIntro: "Preview while the full answer is prepared.",
    waitBridgeAriaLabel: "Interim message while the main answer is prepared",
    placeholderHero: "Talk to the Hero of the Shadows...",
    placeholderFinance: "Talk to the Financial Exorcist...",
    placeholderBlocked: "The Archive has silenced you for this week.",
    ctaBreakSeal: "Break the Seal",
    ctaEnterArchive: "Login",
    ctaLoginTooltip: "Sign in on the official portal.",
    ctaAlreadyHaveSeal: "I already hold the Seal",
    loginRecoverTitle: "Already paid and need access?",
    loginRecoverText: "Use this option for first access, access recovery, or resending the entry link.",
    loginRecoverButton: "Recover access",
    ctaRecoverPaidAccess: "I paid and did not receive the access email",
    ctaObtainFullSeal: "Obtain the Full Seal",
    paywallWeeklyExhausted: "The Archive has silenced you for this week.",
    basicNoAiPremium: "The Archive responds only to holders of the Full Seal.",
    hunterSuggestionKicker: "Hunter Suggestion",
    useSuggestion: "Use suggestion",
    anotherSuggestion: "Another suggestion",
    quickStartKicker: "Hunter Guide",
    quickStartClarity: "See clearly",
    quickStartDirect: "Direct answer",
    quickStartJudgment: "Judge situation",
    quickStartClarityPrefix: "I want to see this situation clearly:",
    quickStartDirectPrefix: "I want a direct answer about:",
    quickStartJudgmentPrefix: "I want your judgment on this situation:",
    quickStartReopen: "Reopen hunter guide",
    reopenHunterSuggestion: "Reopen hunter suggestion",
    closeMiniGuide: "Close",
    send: "Send",
    stop: "Stop",
    blocked: "Blocked",
    voiceTitle: "Voice language",
    stopRecording: "Stop recording",
    startRecording: "Start recording",
    voiceUnavailable: "SpeechRecognition unavailable in this browser",
    voiceUnsupported: "Your browser does not support voice dictation (SpeechRecognition).",
    voiceStartFail: "Failed to start voice recognition.",
    checkoutFail: "Subscription flow is unavailable right now. Check the official pricing page.",
    audiobookSuggested: "Suggested audiobook",
    notNow: "Not now",
    accountMemoryTitle: "Account / Memory",
    planPaidActive: "Paid plan active (until {{date}}).",
    loggedFullActive: "full user logged in",
    planFreeUsed: "Free plan: {{used}}/{{limit}} used.",
    accessReleasedPaywall: "Access released (paywall off).",
    billingUnavailable: "Billing unavailable.",
    doUpgrade: "Upgrade",
    opening: "Opening...",
    monthly: "Monthly",
    yearly: "Yearly",
    memoryLabel: "Memory",
    memoryOn: "on",
    memoryOff: "off",
    consentYes: "yes",
    consentNo: "no",
    memoryStatus: "Memory status unavailable.",
    consentWarning: "Consent required (GDPR). By enabling memory, you authorize storage of your conversations.",
    turnOffMemory: "Turn off memory",
    turnOnMemory: "Turn on memory and give consent",
    deleteSummaries: "Delete summaries",
    deleteHistory: "Delete history",
    keepLast: "Keep last",
    apply: "Apply",
    identityCardTitle: "Identity Card (style only)",
    identityCardHint: "Customizes response format and tone. Does not change morals or rules.",
    tom: "Tone",
    formato: "Format",
    detailLevel: "Detail level",
    avoidPhrases: "Avoid phrases",
    default: "Default",
    short: "Short",
    normal: "Normal",
    bullets: "Bullet list",
    paragraphs: "Short paragraphs",
    low: "Low",
    medium: "Medium",
    avoidFaca: "Avoid \"do X\"",
    avoidPrecisa: "Avoid \"you need\"",
    avoidMelhor: "Avoid \"the best is\"",
    save: "Save",
    restoreDefault: "Restore default",
    clear: "Clear",
    forgetMe: "Forget me (delete all)",
    viewMemories: "View my memories",
    back: "← Back",
    noMemories: "No memories found.",
    youFull: "You (full)",
    hideReply: "Hide reply",
    showReply: "Show reply",
    memoryOnOk: "Memory enabled with consent. Your conversations will now be saved!",
    memoryOffOk: "Memory disabled (consent kept).",
    memoryConsentFail: "Memory enabled but consent failed. Try again or contact support.",
    memoryError: "Error updating memory",
    historyDeleted: "History deleted.",
    historyError: "Error deleting history.",
    historyTrimmed: "History trimmed to keep last {{n}}.",
    summariesDeleted: "Summaries deleted.",
    summariesError: "Error deleting summaries.",
    cardSaved: "Card saved.",
    cardSaveFail: "Failed to save. Try again.",
    formCleared: "Form cleared. Click Save to apply.",
    cardCleared: "Card cleared.",
    cardClearFail: "Failed to clear. Try again.",
    forgetDone: "Forgotten. Reload the page to get a new clean ID.",
    forgetError: "Error executing forget-me.",
    clearHistoryConfirm: "Delete ALL memory history for this user_id?",
    forgetConfirm: "This will delete profile + memories and create a new ID. Continue?",
    deleteMemoryConfirm: "Delete memory #{{n}}?",
    loadMemoriesError: "Error loading memory list.",
    deleteMemoryError: "Error deleting memory.",
    uploadDone: "Upload complete",
    uploadError: "Error sending document",
  },
  es: {
    shieldSubtitle: "Elija el idioma de la plataforma:",
    chooseLang: "Seleccionar idioma",
    legalNotice: "Aviso Legal",
    privacyPolicy: "Política de Privacidad",
    termsOfService: "Términos de Uso",
    pricing: "Precios",
    refunds: "Reembolsos",
    dataRequest: "Solicitar datos",
    about: "Acerca de",
    confidentialFile: "Archivo Confidencial",
    rachelOn: "Rachel-E: ON",
    rachelOff: "Rachel-E: OFF",
    rachelTooltip: "Desactiva la segunda voz Rachel-E.",
    aiBanner: "Está a punto de conocer a un héroe olvidado por el tiempo.\n\nAntes de iniciar este viaje, conozca el origen, la historia y el legado de Van Helsin.",
    checkboxLabel: "Entiendo que este es un sistema narrativo ficticio generado por IA y no constituye asesoramiento profesional.",
    checkboxShort: "He leído y acepto los Términos de Uso.",
    mandatoryCheckbox: "Casilla obligatoria antes de la compra (UE)",
    euConsentTitle: "Consentimiento obligatorio (Consumidor UE)",
    euConsentTerms: "He leído y acepto los Términos de Uso.",
    euConsentWithdrawal: "Consiento expresamente la ejecución inmediata del servicio digital y reconozco que pierdo mi derecho de desistimiento de 14 días una vez que comience el acceso.",
    euConsentConfirm: "Continuar al pago",
    fictionDisclaimer: "Ficción interactiva. Sin asesoramiento profesional.",
    backToChat: "Volver a la IA",
    loginTitle: "Ingrese su email para despertar al Cazador",
    loginButton: "Entrar",
    loginPlaceholder: "su@email.com",
    invalidEmail: "Ingrese un email válido",
    invokeBtn: "Atrévase a Invocar Van Helsin",
    skipIntro: "Saltar Intro",
    introPreparing: "Breve silencio antes de la tormenta…",
    validatingJurisdiction: "Validando jurisdicción",
    validatingWait: "Espere mientras validamos la disponibilidad legal del servicio.",
    geoUnavailable: "Indisponible en su jurisdicción",
    geoCountry: "País detectado",
    geoBrEuOnly: "Servicio disponible solo para residentes de Brasil y la UE.",
    viewLegal: "Ver aviso legal",
    heroOfShadows: "Héroe de las Sombras",
    financialExorcist: "Exorcista Financiero",
    planPaid: "Plan: pago (hasta {{date}})",
    loggedFull: "usuario full logueado",
    planFree: "Gratis: {{left}}/{{total}}",
    accessReleased: "Acceso: liberado",
    loading: "Cargando...",
    switchAI: "Cambiar IA",
    upgrade: "Mejorar",
    planActive: "Plan activo",
    accountMemory: "Cuenta/Memoria",
    authorityCta: "Conoce el origen",
    authorityTooltip: "Conoce el origen, los limites y la propuesta institucional de la IA Van Helsin.",
    authorityStripTitle: "Origen y limites",
    authorityStripText: "Antes de conversar, conoce el origen, los limites y la propuesta de la IA Van Helsin.",
    authorityStripButton: "Conoce el origen",
    musicActive: "Música: activa",
    musicPaused: "Música: pausada",
    musicReconnecting: "Música: reconectando...",
    musicWaiting: "Música: esperando",
    audiobookActive: "Audiobook: activo",
    resumeMusic: "Reanudar música",
    stopMusic: "Parar música",
    resumeAudiobook: "Continuar audiobook",
    stopAudiobook: "Parar audiobook",
    prevMusic: "Música anterior",
    nextMusic: "Siguiente música",
    you: "Usted",
    parableBadge: "Respuesta parabólica",
    onlyConclusion: "Solo la conclusión",
    moreDirectNext: "Más directo en las próximas",
    restoreAutoStyle: "Volver al modo normal",
    showConclusion: "Mostrar",
    hideConclusion: "Ocultar",
    shortConclusionUnavailable: "No hay una conclusion breve confiable disponible para esta respuesta.",
    thinking1: "Van Helsin está analizando su pregunta...",
    thinking2: "Cruzando memorias y contexto para responder con precisión...",
    thinking3: "Organizando la mejor respuesta para usted...",
    thinking4: "Refinando los detalles finales de la respuesta...",
    earlyMicroLabel: "Pre-respuesta",
    earlyMicroIntro: "Avance mientras se prepara la respuesta completa.",
    waitBridgeAriaLabel: "Mensaje provisional mientras se prepara la respuesta principal",
    placeholderHero: "Hable con el Héroe de las Sombras...",
    placeholderFinance: "Hable con el Exorcista Financiero...",
    placeholderBlocked: "El Archivo te ha silenciado por esta semana.",
    ctaBreakSeal: "Romper el Sello",
    ctaEnterArchive: "Login",
    ctaLoginTooltip: "Acceder al login en el portal oficial.",
    ctaAlreadyHaveSeal: "Ya poseo el Sello",
    loginRecoverTitle: "Ya pagó y necesita acceder?",
    loginRecoverText: "Use esta opción para primer acceso, recuperación de acceso o reenvío del enlace de entrada.",
    loginRecoverButton: "Recuperar acceso",
    ctaRecoverPaidAccess: "Pagué y no recibí el correo de acceso",
    ctaObtainFullSeal: "Obtener el Sello Completo",
    paywallWeeklyExhausted: "El Archivo te ha silenciado por esta semana.",
    basicNoAiPremium: "El Archivo responde solo a los portadores del Sello Completo.",
    hunterSuggestionKicker: "Sugerencia del Cazador",
    useSuggestion: "Usar sugerencia",
    anotherSuggestion: "Otra sugerencia",
    quickStartKicker: "Guía del Cazador",
    quickStartClarity: "Ver con claridad",
    quickStartDirect: "Respuesta directa",
    quickStartJudgment: "Juzgar situación",
    quickStartClarityPrefix: "Quiero ver esta situación con claridad:",
    quickStartDirectPrefix: "Quiero una respuesta directa sobre:",
    quickStartJudgmentPrefix: "Quiero tu juicio sobre esta situación:",
    quickStartReopen: "Reabrir guía del cazador",
    reopenHunterSuggestion: "Reabrir sugerencia del cazador",
    closeMiniGuide: "Cerrar",
    send: "Enviar",
    stop: "Interrumpir",
    blocked: "Bloqueado",
    voiceTitle: "Idioma de la voz",
    stopRecording: "Parar grabación",
    startRecording: "Iniciar grabación",
    voiceUnavailable: "SpeechRecognition no disponible en este navegador",
    voiceUnsupported: "Su navegador no admite dictado por voz (SpeechRecognition).",
    voiceStartFail: "Fallo al iniciar el reconocimiento de voz.",
    checkoutFail: "El flujo de suscripción no está disponible en este momento. Consulte la página oficial de precios.",
    audiobookSuggested: "Audiobook sugerido",
    notNow: "Ahora no",
    accountMemoryTitle: "Cuenta / Memoria",
    planPaidActive: "Plan pago activo (hasta {{date}}).",
    loggedFullActive: "usuario full logueado",
    planFreeUsed: "Plan gratis: {{used}}/{{limit}} usados.",
    accessReleasedPaywall: "Acceso liberado (paywall off).",
    billingUnavailable: "Billing indisponible.",
    doUpgrade: "Mejorar",
    opening: "Abriendo...",
    monthly: "Mensual",
    yearly: "Anual",
    memoryLabel: "Memoria",
    memoryOn: "activada",
    memoryOff: "desactivada",
    consentYes: "sí",
    consentNo: "no",
    memoryStatus: "Estado de memoria indisponible.",
    consentWarning: "Consentimiento necesario (GDPR). Al activar la memoria, autoriza el almacenamiento de sus conversaciones.",
    turnOffMemory: "Desactivar memoria",
    turnOnMemory: "Activar memoria y dar consentimiento",
    deleteSummaries: "Borrar resúmenes",
    deleteHistory: "Borrar historial",
    keepLast: "Mantener últimos",
    apply: "Aplicar",
    identityCardTitle: "Tarjeta de Identidad (solo estilo)",
    identityCardHint: "Personaliza formato y tono de las respuestas. No altera moral ni reglas.",
    tom: "Tono",
    formato: "Formato",
    detailLevel: "Nivel de detalle",
    avoidPhrases: "Evitar expresiones",
    default: "Por defecto",
    short: "Corto",
    normal: "Normal",
    bullets: "Lista en temas",
    paragraphs: "Párrafos cortos",
    low: "Bajo",
    medium: "Medio",
    avoidFaca: "Evitar \"haga X\"",
    avoidPrecisa: "Evitar \"usted necesita\"",
    avoidMelhor: "Evitar \"lo mejor es\"",
    save: "Guardar",
    restoreDefault: "Restaurar predeterminado",
    clear: "Borrar",
    forgetMe: "Olvidarme (borrar todo)",
    viewMemories: "Ver mis memorias",
    back: "← Volver",
    noMemories: "Ninguna memoria encontrada.",
    youFull: "Usted (completo)",
    hideReply: "Ocultar respuesta",
    showReply: "Ver respuesta",
    memoryOnOk: "Memoria activada con consentimiento. ¡Sus conversaciones ahora se guardarán!",
    memoryOffOk: "Memoria desactivada (consentimiento mantenido).",
    memoryConsentFail: "Memoria activada pero el consentimiento falló. Intente de nuevo o contacte soporte.",
    memoryError: "Error al actualizar memoria",
    historyDeleted: "Historial borrado.",
    historyError: "Error al borrar historial.",
    historyTrimmed: "Historial ajustado para mantener los últimos {{n}}.",
    summariesDeleted: "Resúmenes borrados.",
    summariesError: "Error al borrar resúmenes.",
    cardSaved: "Tarjeta guardada.",
    cardSaveFail: "Fallo al guardar. Intente de nuevo.",
    formCleared: "Formulario vacío. Haga clic en Guardar para aplicar.",
    cardCleared: "Tarjeta borrada.",
    cardClearFail: "Fallo al borrar. Intente de nuevo.",
    forgetDone: "Olvidado. Recargue la página para obtener un ID limpio.",
    forgetError: "Error al ejecutar olvidarme.",
    clearHistoryConfirm: "¿Borrar TODO el historial de memoria de este user_id?",
    forgetConfirm: "Esto borrará perfil + memorias y creará un nuevo ID. ¿Continuar?",
    deleteMemoryConfirm: "¿Borrar memoria #{{n}}?",
    loadMemoriesError: "Error al cargar lista de memorias.",
    deleteMemoryError: "Error al borrar memoria.",
    uploadDone: "Upload completo",
    uploadError: "Error al enviar documento",
  },
};

/**
 * Detecta idioma: preferência vh_ui_lang > navegador > fallback en
 */
export function detectUiLang() {
  try {
    const stored = sessionStorage.getItem("vh_ui_lang") || "";
    const code = (stored.match(/^(pt|en|es)(-|$)/i) || [])[1]?.toLowerCase();
    if (code) return code;
  } catch {}
  try {
    const nav = (navigator.language || "").toLowerCase();
    if (nav.startsWith("pt")) return "pt";
    if (nav.startsWith("es")) return "es";
  } catch {}
  return "en";
}

/**
 * Obtém tradução para a chave (suporta {{var}} para interpolação)
 */
export function tr(lang, key, vars = {}) {
  const m = t[lang] || t.en;
  let s = m[key] || t.en[key] || key;
  Object.entries(vars).forEach(([k, v]) => {
    s = s.replace(new RegExp(`\\{\\{${k}\\}\\}`, "g"), String(v));
  });
  return s;
}
